module.exports = __webpack_public_path__ + "img/banner_shouquan.d174760c.png";